import React from "react";
import BGimg from "../assets/img/Designer.webp";
import ScrollingBanner from "./ScrollingBanner";
// import TokenImageNAU from "./TokenImageNAU";

const Hero: React.FC = () => {
  const bannerItem = (
    <div className="flex items-center mt-3 gap-4 animate-pulse transition-opacity duration-700">
      {/* <TokenImageNAU /> */}
      {/* <span className="text-white text-base font-bold">
        Presale is now live!
      </span> */}
      <span className="flex items-center gap-2 mx-10">
        <span className="bg-[#00AEEF] text-white text-sm px-3 py-1 rounded-xl font-medium">
          Audit
        </span>{" "}
        <p>and</p>
        <span className="bg-[#28a745] text-white text-sm px-3 py-1 rounded-xl font-medium">
          KYC
        </span>
        <p>completed </p>{" "}
      </span>{" "}
    </div>
  );

  const bannerItems = [bannerItem, bannerItem, bannerItem];

  return (
    <section
      id="hero"
      className="relative flex flex-col md:flex-row items-center justify-center min-h-[80vh] overflow-hidden pt-20"
    >
      <img
        src={BGimg}
        alt="Hero background"
        className="absolute inset-0 w-full h-full object-cover z-0"
        loading="eager"
      />

      <div className="z-10 text-center px-4">
        {/* Place your hero title, subtitle, or CTA here */}
      </div>

      <div className="absolute bottom-0 w-full z-20">
        <ScrollingBanner items={bannerItems} speed={25} />
      </div>
    </section>
  );
};

export default Hero;
